import { render, staticRenderFns } from "./DataProductsDrawerTitle.vue?vue&type=template&id=6036f2c7&scoped=true&lang=pug"
import script from "./DataProductsDrawerTitle.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataProductsDrawerTitle.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DataProductsDrawerTitle.vue?vue&type=style&index=0&id=6036f2c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6036f2c7",
  null
  
)

export default component.exports